module.exports = __webpack_public_path__ + "img/send_letter.2234f6ce.svg";